<template>
    <ul class="provider-list">
        <li :class="['provider', { active: (profileProvider.provider === provider) }]"
            :key="index"
            v-for="(profileProvider, index) in profileProviderList"
            @click="chooseProviderProfile(profileProvider.provider)">
            <b>{{ getProviderNameById(profileProvider.provider) }}</b>
            ({{ getContentKey('profile', profileProvider.profile, 'title') }})
        </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'provider-select',

    data() {
        return {
            provider: ''
        }
    },

    props: {
        profileMap: {
            type: Array,
            required: true
        },
        initialSelect: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        if (this.initialSelect) {
            this.provider = this.profileProviderList[0].provider
            this.$emit('providerSelect', this.provider)
        }
            
    },

    methods: {
        chooseProviderProfile(provider) {
            this.provider = provider
            this.$emit('providerSelect', this.provider)
        }
    },

    computed: {
        ...mapGetters('content', [
            'getContentKey'
        ]),
        ...mapGetters('provider', [
            'getProviderNameById',
            'getProvidersIdArray'
        ]),
        profileProviderList() {
            return this.profileMap
                .map((providerProfile) => ({provider: providerProfile.split(':')[0], profile: providerProfile.split(':')[1]}))
                .filter(({ provider }) => this.getProvidersIdArray.includes(provider))
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

.provider-list {
    list-style-type: none;
    display: flex;
    padding-inline-start: 0;
    margin-block-start: 10px;
    .provider {
        font-size: 14px;
        line-height: 17px;
        border: 1px solid $grey-300;
        border-radius: 14px;
        padding: 5px 12px;
        margin-right: 12px;
        cursor: pointer;
        &.active {
            background-color: $primary-color;
            color: $white-color;
        }
    }
}
</style>